import React, { Component } from 'react'
import { connect } from 'react-redux'
import Header from '../Header'
import { refreshToken, restoreStateKey } from '../../actions'

import 'normalize.css/normalize.css'
import 'primer-buttons/build/build.css'
import './App.css'
import './Forms.css'

class App extends Component {
  constructor(props) {
    super(props)
    const { restoreStateKey } = this.props
    if(localStorage.authentication) {
      restoreStateKey('authentication', JSON.parse(localStorage.authentication))
    }
  }

  render() {
    const { children } = this.props
    return (
      <div className="app">
        <Header {...this.props} />
        { children }
      </div>
    )
  }
}

export default connect( (state) => ({
  authentication: state.authentication
}), { refreshToken, restoreStateKey })(App);


// WEBPACK FOOTER //
// ./src/components/App/App.js